import React, { useContext, useEffect, useState } from 'react';
import './App.scss';
import Header from "./auth/Header";
import Footer from "./auth/Footer";
import IndexRoute from "./routes/IndexRoute";
// import {ApiClient} from "./utils/ApiClient";
import WebVersion from "./pages/WebVersion";
import { useWeb3ModalAccount } from "@web3modal/ethers/react";
import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react';
import { useWeb3Modal, useWeb3ModalProvider } from '@web3modal/ethers/react';
import { ethers } from "ethers";
import { ApiClient } from "./utils/ApiClient";
import WinningsModal from "./components/WinningsModal";
import { getCookie, jackpotReward, saveUrlParamsToCookies, sendImpressionFromCookies, winningsTicket } from "./web3";
import Admin from "./pages/Admin";
import IndexRouteWeb from "./routes/IndexRouteWeb";
import Cookies from "js-cookie";


// 1. Get projectId
const projectId = '74370368811ba66914930f4fb4b97b9d'

// 2. Set chains
const mainnet = {
    chainId: 56,
    // chainId: 97, // testnet
    name: 'BNB Smart Chain',
    currency: 'BNB',
    explorerUrl: 'https://bscscan.io',
    // explorerUrl: 'https://data-seed-prebsc-2-s1.bnbchain.org:8545',
    rpcUrl: 'https://1rpc.io/bnb'
    // rpcUrl: 'https://data-seed-prebsc-2-s1.bnbchain.org:8545'
}

// 3. Create a metadata object
const metadata = {
    name: 'CryptoLottery777',
    description: 'CryptoLottery777',
    url: 'https://cryptolottery777.com/', // origin must match your domain & subdomain
    icons: ["avatar"]
}

// 4. Create Ethers config
const ethersConfig = defaultConfig({
    /*Required*/
    metadata,
    /*Optional*/
    enableEIP6963: true, // true by default
    enableInjected: true, // true by default
    enableCoinbase: true, // true by default
    rpcUrl: '...', // used for the Coinbase SDK
    defaultChainId: 56 // used for the Coinbase SDK
})

// 5. Create a Web3Modal instance
createWeb3Modal({
    ethersConfig,
    chains: [mainnet],
    projectId,
    enableAnalytics: true, // Optional - defaults to your Cloud configuration
    themeMode: "dark",
    themeVariables: {
        "--w3m-font-family": 'Noto Sans Regular',
        "--w3m-accent": "#FFF",
        "--w3m-border-radius-master": "16px",
    },
})

function App() {
    const [provider, setProvider] = useState();
    const [winningModalOpen, setWinningModalOpen] = useState(false);
    const { address, chainId, isConnected, status } = useWeb3ModalAccount();
    const { open } = useWeb3Modal();
    const { walletProvider } = useWeb3ModalProvider(); // Extract walletProvider safely

    useEffect(() => {
        const saveReferrer = () => {
            const path = window.location.pathname; // например "/0xd4BaaeE8B4FC556e9b98cDDf608A372C90c42f81"

            if (path && path.length > 1) {
                const possibleAddress = path.slice(1);

                if (/^0x[a-fA-F0-9]{40}$/.test(possibleAddress)) {
                    // всегда перезаписываем cookie
                    Cookies.set("aff_sub2", possibleAddress, { expires: 30 });
                    console.log("[Referrer] Адрес сохранён в куки:", possibleAddress);
                }
            }
        };

        // сразу при монтировании
        saveReferrer();

        // слушаем изменения url (например при SPA-навигации)
        const handlePopState = () => saveReferrer();
        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    
    useEffect(() => {
         console.log("Saving URL params...");
         saveUrlParamsToCookies();
        sendImpressionFromCookies()
    }, [])


    const apiClientJackpotNotificationsGetByUser = new ApiClient("https://cryptolottery777.com/public/jackpot/notifications");

    useEffect(() => {
        apiClientJackpotNotificationsGetByUser.post({ walletAddress: address }).then(res => {
            if (res) {
                setWinningModalOpen(true)
            }
        });
    }, [address])

    useEffect(() => {
        if (isConnected && walletProvider) {
            getSigner()
        }
    }, [isConnected, walletProvider]); // Re-run when provider is updated

    const getSigner = async () => {
        if (!isConnected) {
            open();
            console.error("Wallet not connected. Please connect your wallet.");
            return;
        }

        if (!walletProvider) {
            console.error("Provider is null. Try reconnecting.");
            return;
        }

        try {
            // Convert the provider into an Ethers.js provider
            const ethersProvider = new ethers.BrowserProvider(walletProvider);

            // Get the signer
            const signer: any = await ethersProvider?.getSigner();
            setProvider(signer)
        } catch (error) {
            console.error("Error getting signer:", error);
        }
    };


    return (
        <div className="App">
            <div className="mob-version">
                <Header
                    address={address}
                    chainId={chainId}
                    isConnected={isConnected}
                    open={open}
                    status={status}
                />
                <IndexRoute
                    address={address}
                    chainId={chainId}
                    isConnected={isConnected}
                    open={open}
                    status={status}
                    provider={provider}
                />
                <div style={{ width: '100%', position: "fixed", bottom: 0 }}>
                    <Footer
                        isConnected={isConnected}
                        open={open}
                        address={address}
                    />
                </div>
            </div>
            <div className="web-version">
                <IndexRouteWeb
                    address={address}
                    chainId={chainId}
                    isConnected={isConnected}
                    open={open}
                    status={status}
                    provider={provider}
                />
            </div>

            <WinningsModal
                winningModalOpen={winningModalOpen}
                setWinningModalOpen={setWinningModalOpen}
                walletAddress={address}
            />
        </div>
    );
}

export default App;
